var map = {
	"./old-phone.svg": "6e8c",
	"./osa_cloud.svg": "1bb2",
	"./osa_device-wireless-router.svg": "55c1",
	"./osa_hub.svg": "ca7c",
	"./osa_iPhone.svg": "fca0",
	"./router.png": "6c5e",
	"./router.svg": "c008",
	"./sky-logo.svg": "6772",
	"./vocus-logo.png": "6835",
	"./vocus-logo.svg": "1de3",
	"./vocus-logo2.png": "c33f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";